import { Context } from "./context.js";
import { createSlice } from "@reduxjs/toolkit";
import React, { useState, useEffect, useRef } from "react";
import * as RB from "react-bootstrap";
import { useSelector, useDispatch, useStore } from "react-redux";
import { MAX_CANVAS_HEIGHT,MAX_CANVAS_WIDTH,MIN_CANVAS_HEIGHT, MIN_CANVAS_WIDTH } from "../../pages/params.js";
const isValid = (left,top,right,bot) => {
    let width = right - left;
    let height = bot - top;
    return (width < MAX_CANVAS_WIDTH && MIN_CANVAS_WIDTH < width &&
            height < MAX_CANVAS_HEIGHT && MIN_CANVAS_HEIGHT < height)
}
export const cropToolSlice = createSlice({
    name: "cropTool",
    initialState: {
        left: -1,
        right: -1,
        top: -1,
        bot: -1,
    },
    reducers: {
        updatePts: (state, action) => {
            let ind = action.payload.ind;
            let pt = action.payload.point;
            switch (ind) {
                case 0:
                    if (isValid(pt[0],pt[1],state.right,state.bot)){
                        state.left = pt[0];
                        state.top = pt[1];
                    }
                    break;
                case 1:
                    if (isValid(state.left,pt[1],pt[0],state.bot)){
                        state.right = pt[0];
                        state.top = pt[1];
                    }
                    break;
                case 2:
                    if (isValid(state.left,state.top,pt[0],pt[1])){
                        state.right = pt[0];
                        state.bot = pt[1];
                    }
                    break;
                case 3:
                    if (isValid(pt[0],state.top,state.right,pt[1])){
                        state.left = pt[0];
                        state.bot = pt[1];
                    }
                    break;
            }
        },
        initPts: (state, action) => {
            if (action.payload.width === 0) {
                return;
            }
            let sX = Math.round(0.1 * action.payload.width);
            let sY = Math.round(0.1 * action.payload.height);
            state.left = sX;
            state.right = action.payload.width - sX;
            state.top = sY;
            state.bot = action.payload.height - sY;
        },
    },
});
const { updatePts, initPts } = cropToolSlice.actions;

export class CropToolCnvControls {
    /**@type {Context} */
    context;
    /**@type {import("redux").Store} */
    store;
    dragInd = -1;
    rad = 6;
    listeners = {};
    static cropCtrl = null;
    static getInstance(context, store) {
        if (this.cropCtrl === null) {
            this.cropCtrl = new CropToolCnvControls(context, store);
            return this.cropCtrl;
        }
        return this.cropCtrl;
    }
    constructor(context, store) {
        this.context = context;
        this.store = store;
        this.listeners = {
            mouseup: this.mUp,
            mousedown: this.mDown,
            mouseleave: this.mLeave,
            mousemove: this.mMove,
        };
    }
    getCropPts = () => {
        let cropProps = this.store.getState().cropTool;
        let pts = [
            [cropProps.left, cropProps.top],
            [cropProps.right, cropProps.top],
            [cropProps.right, cropProps.bot],
            [cropProps.left, cropProps.bot],
        ];
        return pts;
    };
    drawControls = () => {
        if (this.context.offScrCnv.width === 0) {
            return;
        }
        let pts = this.getCropPts(this.store);

        let tr = this.context.cnvCtx.getTransform();
        this.context.cnvCtx.strokeStyle = "green";
        this.context.cnvCtx.lineWidth = 3;
        this.context.cnvCtx.setTransform(1, 0, 0, 1, 0, 0);
        pts = pts.map(this.context.orToView, this.context);
        for (let i = 0; i < pts.length; ++i) {
            let next = (i + 1) % pts.length;
            this.context.cnvCtx.beginPath();
            this.context.cnvCtx.moveTo(pts[i][0], pts[i][1]);
            this.context.cnvCtx.lineTo(pts[next][0], pts[next][1]);
            this.context.cnvCtx.stroke();
        }
        this.context.cnvCtx.fillStyle = "blue";
        this.context.cnvCtx.strokeStyle = "#000033";
        this.context.cnvCtx.lineWidth = 1;
        for (let i = 0; i < pts.length; ++i) {
            this.context.cnvCtx.beginPath();
            this.context.cnvCtx.arc(
                pts[i][0],
                pts[i][1],
                this.rad,
                2 * Math.PI,
                false
            );
            this.context.cnvCtx.fill();
            this.context.cnvCtx.stroke();
        }
        this.context.cnvCtx.setTransform(tr);
    };
    updateImage = () => {
        let pts = this.getCropPts(this.store);

        if (pts[0][0] === -1) {
            this.initState();
            return;
        }
        this.context.updateImage();
        this.drawControls();
    };
    initState = () => {
        let pts = this.getCropPts();
        if (pts[0][0] < 0) {
            this.store.dispatch(
                initPts({
                    width: this.context.offScrCnv.width,
                    height: this.context.offScrCnv.height,
                })
            );
        }
    };
    checkClick = (point) => {
        let pts = this.getCropPts(this.store);
        pts = pts.map((pt) => this.context.orToView(pt));
        for (let i = 0; i < pts.length; ++i) {
            let lt = [pts[i][0] - this.rad, pts[i][1] - this.rad];
            let rb = [pts[i][0] + this.rad, pts[i][1] + this.rad];
            if (
                lt[0] < point[0] &&
                lt[1] < point[1] &&
                rb[0] > point[0] &&
                rb[1] > point[1]
            ) {
                return i;
            }
        }
        return -1;
    };
    mDown = (event) => {
        this.drawControls();
        this.dragInd = this.checkClick([event.offsetX, event.offsetY]);
    };
    mMove = (event) => {
        if (this.dragInd > -1) {
            this.store.dispatch(
                updatePts({
                    ind: this.dragInd,
                    point: this.context.viewToOr([
                        event.offsetX,
                        event.offsetY,
                    ]),
                })
            );
        }
    };
    mUp = (event) => {
        this.dragInd = -1;
    };
    mLeave = (event) => {
        this.dragInd = -1;
    };
}
export const CropProps = (props) => {
    /**@type {Context}*/
    let context = props.context;

    const left = useSelector((state) => state.cropTool.left);
    const right = useSelector((state) => state.cropTool.right);
    const top = useSelector((state) => state.cropTool.top);
    const bot = useSelector((state) => state.cropTool.bot);
    const store = useStore();
    const leftRef = useRef(null);
    const rightRef = useRef(null);
    const topRef = useRef(null);
    const botRef = useRef(null);

    useEffect(()=>{
        leftRef.current.addEventListener('change',(event)=>{
            changeLeft(event);
            leftRef.current.value = store.getState().cropTool.left;
        });
        rightRef.current.addEventListener('change',(event)=>{
            changeRight(event);
            rightRef.current.value = store.getState().cropTool.right;
        });
        topRef.current.addEventListener('change',(event)=>{
            changeTop(event);
            topRef.current.value = store.getState().cropTool.top;
        });
        botRef.current.addEventListener('change',(event)=>{
            changeBot(event);
            botRef.current.value = store.getState().cropTool.bot;
        })
    },[]);
    useEffect(()=>{
        leftRef.current.value = Math.round(left)
        rightRef.current.value = Math.round(right)
        topRef.current.value = Math.round(top)
        botRef.current.value = Math.round(bot)
    },[left,right,bot,top])
    const dispatch = useDispatch();
    const changeLeft = (event) => {
        let pt = [Number(event.target.value), store.getState().cropTool.top];
        dispatch(updatePts({ ind: 0, point: pt }));
    };
    const changeRight = (event) => {
        let pt = [Number(event.target.value),  store.getState().cropTool.bot];
        dispatch(updatePts({ ind: 2, point: pt }));
    };
    const changeTop = (event) => {
        let pt = [store.getState().cropTool.left, Number(event.target.value)];
        dispatch(updatePts({ ind: 0, point: pt }));
    };
    const changeBot = (event) => {
        let pt = [store.getState().cropTool.right, Number(event.target.value)];
        dispatch(updatePts({ ind: 2, point: pt }));
    };

    const applyHandle = (event) => {
        let newW = right - left;
        let newH = bot - top;
        // Save image to curCnv
        context.curCnvCtx.drawImage(context.offScrCnv, 0, 0);
        // Set new size and reset canvas transform
        context.offScrCnv.width = newW;
        context.offScrCnv.height = newH;

        // Translate canvas origin to new selected point
        context.offScrCnvCtx.translate(-left, -top);
        // Draw image on transformed canvas
        context.offScrCnvCtx.drawImage(context.curCnv, 0, 0);
        context.updateImage();
        console.log("Crop applied");
        context.putToHistory();
    };
    const resetHandle = (event) => {
        dispatch(
            initPts({
                width: context.offScrCnv.width,
                height: context.offScrCnv.height,
            })
        );
    };
    const form = (
        <RB.Form>
            <RB.Form.Group className="toolprop">
                <RB.Form.Row>
                    <RB.Col>
                        <RB.Form.Label size="sm">Лево:</RB.Form.Label>
                    </RB.Col>
                    <RB.Col md={7}>
                        <RB.Form.Control
                            ref={leftRef}
                            id="crop-left"
                            size="sm"
                            type="number"
                        ></RB.Form.Control>
                    </RB.Col>
                </RB.Form.Row>
                <RB.Form.Row>
                    <RB.Col>
                        <RB.Form.Label size="sm">Право:</RB.Form.Label>
                    </RB.Col>
                    <RB.Col md={7}>
                        <RB.Form.Control
                            ref={rightRef}
                            id="crop-right"
                            size="sm"
                            type="number"
                        ></RB.Form.Control>
                    </RB.Col>
                </RB.Form.Row>
                <RB.Form.Row>
                    <RB.Col>
                        <RB.Form.Label size="sm">Верх:</RB.Form.Label>
                    </RB.Col>
                    <RB.Col md={7}>
                        <RB.Form.Control
                            ref={topRef}
                            id="crop-top"
                            size="sm"
                            type="number"
                        ></RB.Form.Control>
                    </RB.Col>
                </RB.Form.Row>
                <RB.Form.Row>
                    <RB.Col>
                        <RB.Form.Label size="sm">Низ:</RB.Form.Label>
                    </RB.Col>
                    <RB.Col md={7}>
                        <RB.Form.Control
                            ref={botRef}
                            id="crop-bottom"
                            size="sm"
                            type="number"
                        ></RB.Form.Control>
                    </RB.Col>
                </RB.Form.Row>
                <RB.Form.Row className="button-row">
                    <RB.Button id="crop-apply" onClick={applyHandle} size="sm">
                        Применить
                    </RB.Button>
                    <RB.Button id="crop-reset" onClick={resetHandle} size="sm">
                        Сброс
                    </RB.Button>
                </RB.Form.Row>
            </RB.Form.Group>
        </RB.Form>
    );
    return form;
};
